import { render, staticRenderFns } from "./ClinicSearchPanel.vue?vue&type=template&id=422fe630&scoped=true"
import script from "./ClinicSearchPanel.vue?vue&type=script&lang=js"
export * from "./ClinicSearchPanel.vue?vue&type=script&lang=js"
import style0 from "./ClinicSearchPanel.vue?vue&type=style&index=0&id=422fe630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422fe630",
  null
  
)

export default component.exports